if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const isPDP = window.location.pathname.includes("/products/");
        if (isPDP) {
            let oldHref = location.href;
            new MutationObserver(() => {
                if (oldHref !== location.href) {
                    oldHref = location.href;
                    const variant = new URL(location.href).searchParams.get('variant');
                    setTimeout(() => {
                        const productForm = document.querySelector("[bss-b2b-main-product-form]");
                        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                            productForm
                        });
                    }, 600)
                }
            }).observe(document, {
                subtree: true,
                childList: true
            });
        } 
    }, 3000)
}